<template>
    <svg xmlns="http://www.w3.org/2000/svg" class="e3-svg" :width="Number(size)" :height="Number(size)" viewBox="0 0 24 24">
        <path fill="currentColor" d="M8.59 16.58L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.42z"/>
    </svg>
</template>

<script>
export default {
    name: 'ChevronRightIcon',
    props: {
        size: {
            type: [String, Number],
            default: 24
        }
    }
};
</script>
